<template>
  <div>
    <h4 class="text-uppercase">{{ $t("pickup_data") }}</h4>

    <info-field
      :label="$t('package_type')"
      :value="packageDetail.send_type == 1 ? $t('local') : $t('intercity')"
    />
    <info-field
      :label="$t('shipment_type')"
      :value="packageDetail.order_type == 1 ? $t('package') : $t('document')"
    />

    <h5>{{ $t("postage") }}</h5>
    <div style="display: flex; justify-content: space-between">
      <div>
        <h5 class="mb-2">{{ $t("postage_payer") }}</h5>
        <p style="margin-bottom: 1px; padding-bottom: 1px">
          <label for="pos">
            <input id="pos" type="checkbox" />
            {{ $t("sender") }}
          </label>
        </p>
        <p style="margin-bottom: 1px; padding-bottom: 1px">
          <label for="prim">
            <input id="prim" type="checkbox" />
            {{ $t("receiver") }}
          </label>
        </p>
        <p style="margin-bottom: 1px; padding-bottom: 1px">
          <label for="tre">
            <input id="tre" type="checkbox" />
            {{ $t("third_party") }}
          </label>
        </p>
      </div>
      <div>
        <h5 class="mb-2">{{ $t("pay_type") }}</h5>
        <p style="margin-bottom: 1px; padding-bottom: 1px">
          <label for="got">
            <input id="got" type="checkbox" />
            {{ $t("cash") }}
          </label>
        </p>
        <p style="margin-bottom: 1px; padding-bottom: 1px">
          <label for="fak">
            <input id="fak" type="checkbox" />
            {{ $t("by_invoice") }}
          </label>
        </p>
        <p style="margin-bottom: 1px; padding-bottom: 1px">
          <label for="bex">
            <input id="bex" type="checkbox" />
            {{ $t("cashless") }}
          </label>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import InfoField from "./InfoField.vue";

export default {
  name: "PickupData",
  components: {
    InfoField,
  },
  props: {
    packageDetail: {
      type: Object,
      required: true,
    },
  },
};
</script>
